import { slideDown } from "../utils/animations"

document.querySelector('a[href="#open-form"]')?.addEventListener('click', async evt => {
    evt.preventDefault()
    await slideDown(document.querySelector('.landingpage-form'))
})